
















import Vue, { PropType } from 'vue'
import { SpellFilter } from '@/util/spell-filter'
import ClassSelect from '@/components/selects/ClassSelect.vue'
import SchoolSelect from '@/components/selects/SchoolSelect.vue'
import LevelSelect from '@/components/selects/LevelSelect.vue'
import FilterIcon from '@/components/icons/FilterIcon.vue'

export default Vue.extend({
  name: 'SpellListFilter',
  data () {
    return {
      showFilter: false,
    }
  },
  props: {
    value: {
      type: Object as PropType<SpellFilter>,
      required: true,
    },
  },
  components: {
    ClassSelect,
    SchoolSelect,
    LevelSelect,
    FilterIcon,
  },
  methods: {
    update (key: string, value: any) {
      if (key === 'level') {
        value = Number(value)
      }
      this.$emit('input', { ...this.value, [key]: value })
    },
  },
})
